/*eslint-disable */

export default {
  getChatbotPromptResponse(state) {
    return state.chatbotPromptResponse
  },
  getLastUpdatedTime(state) {
    return state.lastUpdatedTime
  }
}